import { disabledLocalesForVat } from '../constants/locale.js';

const getPrice = (price, vatInc) => price?.[vatInc ? "taxed" : "untaxed"];
const validatePriceValue = (value, paramName) => {
  if (value !== void 0 && typeof value === "number" && value < 0) {
    throw new Error(`validation failed: ${paramName} invalid value, needs a number greater or equal than 0, current value: ${value}`);
  }
};
const isVatDisabledForLocale = (locale) => {
  return disabledLocalesForVat.some((unitLocale) => unitLocale.toLowerCase() === locale.toLowerCase());
};

export { getPrice, isVatDisabledForLocale, validatePriceValue };
